<template>
  <div class="collections-container-phone">
    <div class="row">
      <div class="d-flex flex-column justify-content-between align-items-start w-100">
        <p class="merriweather-bold-p16 pl-4 text-center w-100">Nos collections</p>

        <div class="collection-section px-4 py-3">
          <div
            v-for="collection in collections"
            :key="collection.id"
            @click="goToCollection(collection.slug)"
          >
            <div class="raleway-bold-p13 text-uppercase text-left item-link no-translate">
              {{ collection.name }}
            </div>
            <div class="mt-1 raleway-medi-p15 text-left item-link-subtitle">
              {{ formatSlug(collection.slug) }}
            </div>
          </div>
        </div>

        <div class="align-items-center all-collections d-flex justify-content-center pt-4 w-100">
          <a href="/collections" class="hortense-btn-primary raleway-bold-p" target="_blank">TOUTES NOS COLLECTIONS</a>
        </div>
        <div class="w-100 d-flex justify-content-center align-items-center px-4 py-4">
          <img
            src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+collections.jpg"
            alt="Collections"
            class="img-collection pr-2"
          />
        </div>
        
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'CollectionsList',
  props: ['collections'],
  methods: {
    formatSlug(slug) {
      if (!slug) return '';
      
      let formatted = slug.replace(/-/g, ' ');
      
      formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
      formatted = formatted.replace(/\bSejour\b/g, 'Séjour');

      return formatted;
    },
    goToCollection(slug) {
      window.open(`/collections/${slug}`, '_blank');
    }
  }
}
</script>

<style scoped>
.collections-container-phone {
  text-transform: capitalize !important;

  .img-collection {
    width: 337px;
    height: 195px;
    object-fit: cover;
  }

  .collection-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>